export enum RequiredOptionsLogic {
  All = 'All',
  Any = 'Any'
}
